import { EventListener } from "./Event";
import { Layout } from "../components/layout/Layout";
import { LayoutLoadEvent } from "./LayoutLoadEvent";

export interface LayoutLoadErrorListener extends EventListener {
    (event: LayoutLoadErrorEvent): void;
}

export class LayoutLoadErrorEvent extends LayoutLoadEvent {
    private _errorMessage: string;

    constructor(target: Layout, errorMessage: string) {
        super(target);
        this._errorMessage = errorMessage;
    }

    public get errorMessage(): string {
        return `Unable to access ${this.target.title || this.target.layoutName}.\n\n${this._errorMessage}`;
    }
}
